import { db } from '../firebase';
import { collection, doc, setDoc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { User, Team } from '../types/user';

// 建立使用者資料
export const createUser = async (userData: Omit<User, 'createdAt' | 'updatedAt'>): Promise<void> => {
  const userRef = doc(db, 'users', userData.uid);
  await setDoc(userRef, {
    ...userData,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });
};

// 更新使用者資料
export const updateUser = async (uid: string, userData: Partial<User>): Promise<void> => {
  const userRef = doc(db, 'users', uid);
  
  try {
    // 先嘗試更新
    await updateDoc(userRef, {
      ...userData,
      updatedAt: serverTimestamp()
    });
  } catch (error: any) {
    // 如果文檔不存在，則創建新文檔
    if (error.code === 'not-found' || error.message?.includes('No document to update')) {
      console.log(`📝 使用者文檔不存在，創建新文檔: ${uid}`);
      await setDoc(userRef, {
        uid,
        ...userData,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
    } else {
      // 其他錯誤則重新拋出
      throw error;
    }
  }
};

// 取得使用者資料
export const getUser = async (uid: string): Promise<User | null> => {
  const userRef = doc(db, 'users', uid);
  const userSnap = await getDoc(userRef);
  if (userSnap.exists()) {
    return userSnap.data() as User;
  }
  return null;
}; 